// extracted by mini-css-extract-plugin
export default {"root":"IconStatusButton_root__28AN5"};